import React from 'react'
import {
  Show,
  TextField,
  BooleanField,
  DateField,
  FunctionField,
  ArrayField,
  Datagrid,
  TopToolbar,
  useRecordContext,
} from 'react-admin';
import { Button, Box } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

const DownloadPdfButton = () => {
  const record = useRecordContext();
  if (!record || !record.pdf_url) return null;
  return (
    <Button
      variant="contained"
      color="primary"
      size="small"
      startIcon={<DownloadIcon />}
      href={record.pdf_url}
      target="_blank"
      rel="noopener noreferrer"
    >
      Download PDF
    </Button>
  );
};

const ReportShowActions = () => (
  <TopToolbar>
    <DownloadPdfButton />
  </TopToolbar>
);

const ReportShow = (props) => {
  return (
    <Show {...props} title="Report Details" actions={<ReportShowActions />}>
      <Box display="flex" flexDirection="column" gap={2} padding={2}>
        <TextField source="id" label="ID" />
        <BooleanField source="published" label="Published" />
        <FunctionField
          label="Vet case"
          render={record => {
            if (!record.vet_case) return '—';
            if (typeof record.vet_case === 'string') return record.vet_case;
            const vc = record.vet_case;
            const horse = vc.horse && typeof vc.horse === 'object' ? vc.horse.name : (vc.horse || '—');
            return `${horse}${vc.case_number ? ` (#${vc.case_number})` : ''}`;
          }}
        />
        <DateField source="creation_date" label="Created at" showTime />
        <DateField source="update_date" label="Updated at" showTime />
        <ArrayField source="pages">
          <Datagrid bulkActionButtons={false}>
            <TextField source="id" label="Page ID" />
            <TextField source="page_index" label="Page index" />
            <FunctionField
              label="Template"
              render={record => {
                if (!record.template) return '—';
                if (typeof record.template === 'string') return record.template;
                return record.template.name || record.template.id;
              }}
            />
          </Datagrid>
        </ArrayField>
      </Box>
    </Show>
  );
};

export default ReportShow;
